import { render } from "./RegulatoryDocumentPage.vue?vue&type=template&id=375858b2"
import script from "./RegulatoryDocumentPage.vue?vue&type=script&lang=js"
export * from "./RegulatoryDocumentPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__